import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { ApiService } from '@env-lib/api/api.service'
import { Observable } from 'rxjs'
import { map } from 'rxjs/operators'
import {
    ContractNotificationLevel,
    ContractsMetadata,
    ContractsMetadataResponse,
} from './contract.model'

@Injectable({
    providedIn: 'root',
})
export class ContractsMetadataService {
    constructor(
        private api: ApiService,
        private readonly http: HttpClient
    ) {}

    fetchContractData(): Observable<ContractsMetadata> {
        const url = `${this.api.contracts.backendUrl}/v2/contracts/widgets/summary`
        return this.http.get<ContractsMetadataResponse>(url).pipe(
            map<ContractsMetadataResponse, ContractsMetadata>((data) => {
                const warningNotifiaction = data.notifications.find(
                    ({ level }) => level === ContractNotificationLevel.Warn
                )
                const alertNotifiaction = data.notifications.find(
                    ({ level }) => level === ContractNotificationLevel.Alert
                )

                return {
                    contractsCount: data.contractsCount,
                    hintsCount: warningNotifiaction
                        ? warningNotifiaction.count
                        : 0,
                    issuesCount: alertNotifiaction
                        ? alertNotifiaction.count
                        : 0,
                } as ContractsMetadata
            })
        )
    }
}
